import React, { useState } from "react";
import "./header.scss";
import Hamburger from "../Dashboard/Hamburger/Hamburger";
import Notifications from "../Dashboard/Notifications/Notifications";
import { joinClasses } from "../../utils/helpers";
import bellIcon from "../../assets/images/bell.svg";
import bellIconWithDot from "../../assets/images/bell-unread.svg";
import hamburgerIcon from "../../assets/images/hamburger.svg";
import closeIcon from "../../assets/images/close.svg";
import MultiProductHeader from "./MultiProductHeader";
import withFeatureFlags from "../FeatureFlags/withFeatureFlags";
import { useCurrentUser } from "../../contexts/CurrentUserProvider";
import Button from "../Form/Button/Button";

/** @import {DashboardHeaderProps} from './DashboardHeaderTypes' */
/** @import {WithFeatureFlagsProps} from '../FeatureFlags/FeatureFlagsTypes' */

function DashboardHeader(/** @type {DashboardHeaderProps} */ {
  notifications,
  removeNotification,
}) {
  const currentUser = useCurrentUser();

  const [hamburgerOpen, setHamburgerOpen] = useState(false);

  const toggleHamburger = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!hamburgerOpen) setNotificationsOpen(false);
    setHamburgerOpen(!hamburgerOpen);
  };

  const [notificationsOpen, setNotificationsOpen] = useState(false); //!localStorage.getItem(`${localStorage.getItem('iuid')}-seen-blad`));
  localStorage.setItem(`${localStorage.getItem("iuid")}-seen-blad`, "true");

  const toggleNotifications = (/** @type {React.MouseEvent<HTMLElement, MouseEvent> | undefined} */ event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (notificationsOpen) notifications.forEach((x) => x.markAsRead());
    if (!notificationsOpen) setHamburgerOpen(false);
    setNotificationsOpen(!notificationsOpen);
  };

  let className = joinClasses(
      "header",
      "header--dashboard",
      hamburgerOpen ? "header--hamburger-open" : ""
  );

  return (
      <header className={className}>
        <div className="header__wrapper">
          <a href="/">
            <div className="header__logo" />
          </a>
          <div className="header__links">
            <a
                href="#"
                onClick={toggleNotifications}
                className="header__link header__link--notifications"
            >
              <img
                  src={
                    notifications.filter((x) => !x.read()).length <= 0
                        ? bellIcon
                        : bellIconWithDot
                  }
              />
            </a>
            <a
                href="#"
                onClick={toggleHamburger}
                className="header__link header__link--hamburger"
            >
              <img src={hamburgerOpen ? closeIcon : hamburgerIcon} />
            </a>
            <Button variant='text'
                    size='med'
                    label='Log out'
                    onClick={() => {
                      if (currentUser && currentUser.logout)
                        currentUser.logout();
                    }}
            />
          </div>
        </div>
        <Notifications
            open={notificationsOpen}
            onClose={toggleNotifications}
            notifications={notifications}
            removeNotification={removeNotification}
        />
        <Hamburger
            open={hamburgerOpen}
            onDismiss={() => setHamburgerOpen(false)}
        />
      </header>
  );
};

function DashboardHeaderCombined(/** @type {DashboardHeaderProps & WithFeatureFlagsProps} */ props) {
  const currentUser = useCurrentUser();

  const isLoggedIn = currentUser?.isAuthenticated;

  return (
      <div>
        {isLoggedIn && <DashboardHeader {...props} />}
        {!isLoggedIn && <MultiProductHeader {...props} />}
      </div>
  );
};

export default withFeatureFlags(DashboardHeaderCombined);
